/* eslint-disable */

import React, { useEffect } from "react";
import { MobXProviderContext } from "mobx-react";
import { reaction } from 'mobx';

function TestView() {
    const { testStore } = React.useContext(MobXProviderContext);


    useEffect(() => {
        reaction(
            () => testStore.list.length,
            pedidos => {
                console.log("Energy level:", pedidos)
            })
    }, []);



    return (
        <div className="App">
            test
            <button onClick={() => testStore.addList()}>test</button>
        </div>


    );
}

export default TestView;
